import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2WorkcodeElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2WorkcodeElFindParams, unknown>

const fetchWorkCodeList = async (params: ApiV2WorkcodeElFindParams) => {
  const { data } = await apiClient.v2.apiV2WorkcodeElFind(params);
  return checkApiResponse(data);
}

export const v2WorkCodeKeys = {
  all: [QUERY_KEY.v2apiV2WorkcodeElFind] as const,
  list: (params: ApiV2WorkcodeElFindParams) => [...v2WorkCodeKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2WorkCodeFindQueryOptions(params))` */
export const v2WorkCodeFindQueryOptions = (params: ApiV2WorkcodeElFindParams) => ({
  queryKey: v2WorkCodeKeys.list(params),
  queryFn: () => fetchWorkCodeList(params),
})

export const useV2WorkCodeFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2WorkCodeKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchWorkCodeList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}

/**
 * 근무코드 목록 표준 조회 — FCM 미커버, staleTime 5분.
 * 특수 조건 조회(기간 필터·keyword 등)는 기존 v2WorkCodeFindQueryOptions 를 그대로 사용한다 (staleTime 0 유지).
 */
export const v2WorkCodeListQueryOptions = (hospitalID: string) => ({
  // swagger 생성 타입이 hospitalID 를 boolean 으로 잘못 문서화하고 있어 캐스팅 (서버 스웨거 주석 오류)
  ...v2WorkCodeFindQueryOptions({ hospitalID, isRemoved: false, key: 'sortNum', way: 1 } as unknown as ApiV2WorkcodeElFindParams),
  staleTime: 5 * 60 * 1000,
  gcTime: 5 * 60 * 1000,
})
